import { AvailabilitySocketActivityPayload } from '../socket/types';
import { StatusType } from './constants';
import { AvailabilityUserResponse, CurrentAvailabilityUser } from './types';

const STATUS_VALUES = new Set<StatusType>(Object.values(StatusType));

export const toStatusType = (value?: StatusType | null): StatusType =>
  value && STATUS_VALUES.has(value) ? value : StatusType.WORKING_INTERRUPTIBLE;

export const getStatusFromActivity = (payload?: AvailabilitySocketActivityPayload | null): StatusType =>
  toStatusType(payload?.state ?? payload?.status);

export const matchesCurrentUser = (
  currentUser: Pick<CurrentAvailabilityUser, 'id' | 'email'>,
  payload?: AvailabilitySocketActivityPayload | null,
) => {
  if (!payload) {
    return false;
  }

  if (payload.employeeId && payload.employeeId === currentUser.id) {
    return true;
  }

  if (payload.employeeEmail && payload.employeeEmail === currentUser.email) {
    return true;
  }

  return !payload.employeeId && !payload.employeeEmail;
};

export const isAvailableFeatures = (data?: AvailabilityUserResponse) => {
  if (typeof data?.isRegistered === 'boolean') {
    return data.isRegistered;
  }

  return false;
};
